import { default as PageLoaderjV0OI58hu4Meta } from "/home/vsts/work/1/s/pages/_dev/PageLoader.vue?macro=true";
import { default as ToastykEs61YJwHmMeta } from "/home/vsts/work/1/s/pages/_dev/Toasty.vue?macro=true";
import { default as _91_46_46_46path_93TTYQsNQEPYMeta } from "/home/vsts/work/1/s/pages/[...path].vue?macro=true";
import { default as address_45bookr2U2D6o3D5Meta } from "/home/vsts/work/1/s/pages/account/address-book.vue?macro=true";
import { default as index1lyyw9BHOgMeta } from "/home/vsts/work/1/s/pages/account/index.vue?macro=true";
import { default as indexD4LySQcvIrMeta } from "/home/vsts/work/1/s/pages/account/invoices/index.vue?macro=true";
import { default as manage_45usersPKq2V3lNZaMeta } from "/home/vsts/work/1/s/pages/account/manage-users.vue?macro=true";
import { default as _91orderNumber_93UAPr16UZoaMeta } from "/home/vsts/work/1/s/pages/account/order-history/[orderNumber].vue?macro=true";
import { default as index5d72ODKGPxMeta } from "/home/vsts/work/1/s/pages/account/order-history/index.vue?macro=true";
import { default as statementsCWkQcOucX5Meta } from "/home/vsts/work/1/s/pages/account/statements.vue?macro=true";
import { default as unsubmittedaN0RMaDTL4Meta } from "/home/vsts/work/1/s/pages/account/unsubmitted.vue?macro=true";
import { default as attention_45requiredw4KaIuTE44Meta } from "/home/vsts/work/1/s/pages/attention-required.vue?macro=true";
import { default as basketm1Wv940PueMeta } from "/home/vsts/work/1/s/pages/basket.vue?macro=true";
import { default as logini6Htc8i9t2Meta } from "/home/vsts/work/1/s/pages/login.vue?macro=true";
import { default as pleatedL2EqMXsg2GMeta } from "/home/vsts/work/1/s/pages/products/pleated.vue?macro=true";
import { default as samplesnI6HAHD4OEMeta } from "/home/vsts/work/1/s/pages/samples.vue?macro=true";
import { default as searchMkXoykAuUKMeta } from "/home/vsts/work/1/s/pages/search.vue?macro=true";
import { default as basketNuXSsgdaPpMeta } from "/home/vsts/work/1/s/pages/spares/basket.vue?macro=true";
import { default as index9ygLAlUU3ZMeta } from "/home/vsts/work/1/s/pages/spares/index.vue?macro=true";
export default [
  {
    name: "_dev-PageLoader",
    path: "/_dev/PageLoader",
    component: () => import("/home/vsts/work/1/s/pages/_dev/PageLoader.vue")
  },
  {
    name: "_dev-Toasty",
    path: "/_dev/Toasty",
    component: () => import("/home/vsts/work/1/s/pages/_dev/Toasty.vue")
  },
  {
    name: "path",
    path: "/:path(.*)*",
    component: () => import("/home/vsts/work/1/s/pages/[...path].vue")
  },
  {
    name: "account-address-book",
    path: "/account/address-book",
    component: () => import("/home/vsts/work/1/s/pages/account/address-book.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/home/vsts/work/1/s/pages/account/index.vue")
  },
  {
    name: "account-invoices",
    path: "/account/invoices",
    meta: indexD4LySQcvIrMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/invoices/index.vue")
  },
  {
    name: "account-manage-users",
    path: "/account/manage-users",
    meta: manage_45usersPKq2V3lNZaMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/manage-users.vue")
  },
  {
    name: "account-order-history-orderNumber",
    path: "/account/order-history/:orderNumber()",
    meta: _91orderNumber_93UAPr16UZoaMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/order-history/[orderNumber].vue")
  },
  {
    name: "account-order-history",
    path: "/account/order-history",
    meta: index5d72ODKGPxMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/order-history/index.vue")
  },
  {
    name: "account-statements",
    path: "/account/statements",
    meta: statementsCWkQcOucX5Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/statements.vue")
  },
  {
    name: "account-unsubmitted",
    path: "/account/unsubmitted",
    meta: unsubmittedaN0RMaDTL4Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/account/unsubmitted.vue")
  },
  {
    name: "attention-required",
    path: "/attention-required",
    meta: attention_45requiredw4KaIuTE44Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/attention-required.vue")
  },
  {
    name: "basket",
    path: "/basket",
    component: () => import("/home/vsts/work/1/s/pages/basket.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logini6Htc8i9t2Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/login.vue")
  },
  {
    name: "products-pleated",
    path: "/products/pleated",
    component: () => import("/home/vsts/work/1/s/pages/products/pleated.vue")
  },
  {
    name: "samples",
    path: "/samples",
    component: () => import("/home/vsts/work/1/s/pages/samples.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/vsts/work/1/s/pages/search.vue")
  },
  {
    name: "spares-basket",
    path: "/spares/basket",
    component: () => import("/home/vsts/work/1/s/pages/spares/basket.vue")
  },
  {
    name: "spares",
    path: "/spares",
    component: () => import("/home/vsts/work/1/s/pages/spares/index.vue")
  }
]